<template>
  <v-menu :close-on-content-click="false" top right>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon v-if="text === '' || text === null">mdi-filter</v-icon>
        <v-badge color="primary" v-else dot>
          <v-icon color="primary">mdi-filter</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card class="py-0 px-4" elevation="0">
      <v-text-field
        v-model="text"
        :label="label"
        :placeholder="placeholder"
        clearable
        @click:clear="clearable()"
        @keydown="keyDown()"
        @keyup="keyUp()"
      ></v-text-field>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    query: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    localFilter: {
      type: String,
      default: "local",
    },
    upperCase: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      text: "",
      typingTimer: "",
    };
  },
  methods: {
    clearable() {
      this.text = "";
      this.$emit("clearable", { [`${this.query}`]: undefined });
    },

    keyDown() {
      clearTimeout(this.typingTimer);
    },

    keyUp() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (this.localFilter == "api") {
          this.$emit("texValue", {
            [`${this.query}`]: `%${
              this.upperCase ? this.text.toUpperCase() : this.text
            }%`,
          });
          return;
        }
        this.$emit("texValue", {
          [`${this.query}`]: `${this.text.toUpperCase()}`,
        });
      }, 1000);
    },
  },
};
</script>

<style></style>
